export default "__VITE_ASSET__CcgQ13LL__"